import {stepForwardSvg as Icon__small__stepForwardSvg} from '../Icon__small/Icon__small--stepForward.js';

export var stepForward = {
  name: 'stepForward',
  category: 'icon',
  colorable: true,
  svg: Icon__small__stepForwardSvg,
};
